import React from 'react';

const Footer = () => {
	return (
		<div>
			<footer style={{ height: '60px', background: '#ffc864' }}>
				<p className="text-center" style={{ padding: '24px 0 0', margin: '10px 0 0' }}>
					Web App Developed By <a href="sunyadhussain.net">Sunyad</a>
				</p>
			</footer>
		</div>
	);
};

export default Footer;
